<template>
  <div :key="componentKey">
    <event-registry-commands-widget
      v-if="isLoaded && error == null"
      :contractId="contractId"
      :currencyCodes="getCurrencyCode"
      @updateCurrentContract="updateCurrentContract"/>

    <div v-if="error">
      <server-error :error="error" />
    </div>

    <div v-if="isLoaded && error == null">
      <ContractDataEdit
        :prevRoute="prevRoute"
        :currentContract="currentContractForEdit"
        :contractEventsLength="currentContractEvents.length"
        @updateCurrentContract="updateCurrentContract"/>
    </div>

  </div>
</template>

<script>
import ContractDataEdit from "../components/registry/contracts/edit/ContractDataEdit";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      error: null,
      currentContractForEdit: null,
      currentContractEvents: [],
      prevRoute: null,
      componentKey: 0,
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from.fullPath;
    })
  },
  components: {
    ContractDataEdit,
  },
  computed: {
    ...mapGetters(["getCurrencyCode"]),
    contractId() {
      return this.$route.params.id;
    }
  },
  async created() {
    this.$store.commit("SET_CONTRACT_RAW_EDITING_STATE", false);
    this.$store.commit("SET_CONTRACT_CHANGE_CONDITION_STATE", false);
    let eventId = null;

    if (this.$route.query.eventId !== undefined) {
      eventId = this.$route.query.eventId;
    }

    try {
      this.error = null;
      this.$loadingManager.addLoadingStep(1);
      if (eventId !== null) {
        this.currentContractForEdit = await this.$store.dispatch(
          "getContractAggregateByIdAndEventId",
          {
            id: this.contractId,
            eventId: eventId
          }
        );
      } else {
        this.currentContractForEdit = await this.$store.dispatch(
          "getContractAggregateById",
          this.contractId
        );
      }

      await Promise.all([
        this.$store.dispatch("getAllCounterparties"),
        this.$store.dispatch("loadAllUnderlyingAssetTypes"),
        this.$store.dispatch('loadAllBusinessUnits'),
        this.$store.dispatch("loadAllAssets"),
        this.$store.dispatch("getUnitOfMeasure"),
        this.$store.dispatch("loadAllFrequencies"),
        this.$store.dispatch("loadLeaseFrequency"),
        this.$store.dispatch("loadAllPaymentName"),
        this.$store.dispatch("loadAllPaymentTypes"),
        this.$store.dispatch("loadContractSettings"),
        this.$store.dispatch("loadAllCurrencyCode"),
        this.$store.dispatch('indexationPlugin/loadAllIndexations'),
        this.$store.dispatch('getContractAssetComponentData', this.contractId)
      ]);

      this.$loadingManager.loadingStepLoaded();
    } catch (e) {
      this.$loadingManager.hideLoadScreen();
      this.error = e;
    }
  },
  methods: {
    navigate(componentName) {
      this.$router.push({ name: componentName });
    },
    async updateCurrentContract() {
      this.currentContractForEdit = await this.$store.dispatch(
        "getContractAggregateById",
        this.contractId,
      );
      this.forceRerender();
    },
    forceRerender() {
      this.componentKey += 1;
    },
  },
};
</script>
